export default "__VITE_ASSET__bf137003__"